import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./analytics/firebase";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import TermsAndConditions from "./screens/TermsAndConditions";
import DeleteAccount from "./screens/DeleteAccount";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const InitialRoute = () => {
  useEffect(() => {
    window.location.assign("/apps/spoty-parking");
  }, []);

  return <div></div>;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <InitialRoute />,
  },
  {
    path: "/apps/spoty-parking",
    element: <App appName="spoty" />,
  },
  {
    path: "/apps/guia-de-bolso-cristao",
    element: <App appName="guia-de-bolso-cristao" />,
  },
  {
    path: "/apps/freshcura",
    element: <App appName="freshcura" />,
  },
  {
    path: "/apps/little-pilgrim",
    element: <App appName="little-pilgrim" />,
  },
  {
    path: "/apps/:app/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/apps/:app/terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/apps/:app/delete-account",
    element: <DeleteAccount />,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
